export class ValidationMessage {
    Category: string;
    MessageText: string;
}

export default ValidationMessage;